import { render, staticRenderFns } from "./estadisticasLeecheros.vue?vue&type=template&id=1c561d0a&scoped=true"
import script from "./estadisticasLeecheros.vue?vue&type=script&lang=js"
export * from "./estadisticasLeecheros.vue?vue&type=script&lang=js"
import style0 from "./estadisticasLeecheros.vue?vue&type=style&index=0&id=1c561d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c561d0a",
  null
  
)

export default component.exports